import React, { useEffect, useContext, useReducer } from 'react';
import reducer from '../reducers/cart_reducer';
import {
  ADD_TO_CART,
  REMOVE_CART_ITEM,
  TOGGLE_CART_ITEM_AMOUNT,
  CLEAR_CART,
  COUNT_CART_TOTALS,
} from '../actions';

const getLocalStorage = () => {
  let cart = localStorage.getItem('cart');

  if (cart) {
    try {
      const parsedCart = JSON.parse(cart);
      // Validation: Ensure items have new schema properties or valid structure.
      // If we switched from Furniture to Fashion, old items might lack 'size' or have 'colors' array instead of string.
      // Let's just clear if it looks suspicious or just check if it is an array.
      // Better: Check if any item represents an "old" product.
      // For now, let's just return parsedCart, but we will add an effect to clear if invalid.
      return Array.isArray(parsedCart) ? parsedCart : [];
    } catch (e) {
      return [];
    }
  } else {
    return [];
  }
};

const initialState = {
  cart: getLocalStorage(),
  total_items: 0,
  total_amount: 0,
  shipping_fee: 0,
};

const CartContext = React.createContext();

export const CartProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const addToCart = (id, color, size, amount, product, expressDelivery = false) => {
    dispatch({
      type: ADD_TO_CART,
      payload: { id, color, size, amount, product, expressDelivery },
    });
  };

  const removeItem = (id) => {
    dispatch({ type: REMOVE_CART_ITEM, payload: id });
  };

  const toggleAmount = (id, value) => {
    dispatch({ type: TOGGLE_CART_ITEM_AMOUNT, payload: { id, value } });
  };

  const clearCart = () => {
    dispatch({ type: CLEAR_CART });
  };

  useEffect(() => {
    dispatch({ type: COUNT_CART_TOTALS });
    localStorage.setItem('cart', JSON.stringify(state.cart));
  }, [state.cart]);

  // Securely wipe Cart data when a user logs out to prevent leaks on shared devices
  useEffect(() => {
    const handleLogout = () => clearCart();
    window.addEventListener('userLoggedOut', handleLogout);
    return () => window.removeEventListener('userLoggedOut', handleLogout);
  }, []);

  return (
    <CartContext.Provider
      value={{ ...state, addToCart, removeItem, toggleAmount, clearCart }}
    >
      {children}
    </CartContext.Provider>
  );
};
// make sure use
export const useCartContext = () => {
  return useContext(CartContext);
};
